import ApiFetchers from "@/apis/api_fetchers"
import useTransactionList from "@/features_signal/transactionRecord/transaction_list"
import Amount from "@/pages/TransactionRecordPage/components/Amount"
import DateText from "@/pages/TransactionRecordPage/components/DateText"
import ItemStatus from "@/pages/TransactionRecordPage/components/ItemStatus"
import ItemTitle from "@/pages/TransactionRecordPage/components/ItemTitle"
import {
    ItemWrapper,
    Left as LeftWrapper,
    Right as RightWrapper,
} from "@/pages/TransactionRecordPage/components/Wrappers"
import { memo, useCallback } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import BaseRecordList from "../components/BaseRecordList"
import { depositStatus } from "../constants"
import { BaseFormType } from "../types"
import { deduplicationList, getFormData, getURLSearchParams } from "../utils/util"
import FootDataCount from "@/pages/TransactionRecordPage/components/FootDataCount"
import { Virtuoso } from "react-virtuoso"

const Component: React.FC = () => {
    const [params, setParams] = useSearchParams()
    const navigate = useNavigate()
    const { list, loading, fetchData, hasMore, error } = useTransactionList(
        ApiFetchers.getFinanceDepositList,
        {
            ...getFormData({ ...getURLSearchParams(params) }),
        },
    )

    const handleChange = useCallback(
        (value?: BaseFormType) => {
            setParams(value ? { ...value } : {}, { replace: true })
        },
        [setParams],
    )

    const uniqueList = deduplicationList<TransactionApiTypes.Fetcher.Response.Record>(list) || []

    const loadMoreDebounced = () => {
        if (!hasMore) return
        if (loading) return
        fetchData()
    }
    return (
        <>
            <BaseRecordList<TransactionApiTypes.Fetcher.Response.Record>
                value={getURLSearchParams(params)}
                statusOptions={depositStatus}
                onChange={handleChange}
                list={uniqueList}
                loading={loading}
                error={error}
                hasMore={hasMore}
                selectTitle="Select Status"
            >
                <Virtuoso
                    style={{ flex: 1 }}
                    data={uniqueList}
                    endReached={loadMoreDebounced}
                    components={{
                        Footer: () => (
                            <FootDataCount
                                loading={loading}
                                hasMore={hasMore}
                                count={list.length}
                            />
                        ),
                    }}
                    itemContent={(_, item) => (
                        <ItemWrapper
                            key={item.id}
                            className={item.status}
                            onClick={() => {
                                navigate(`/s-transaction/status?id=${item.id}&type=deposit`)
                            }}
                        >
                            <LeftWrapper>
                                <ItemTitle text={item.name} />
                                <DateText timestamp={item.timestamp} />
                            </LeftWrapper>
                            <RightWrapper>
                                <Amount amount={item.amount} />
                                <ItemStatus text={item.status} />
                            </RightWrapper>
                        </ItemWrapper>
                    )}
                />
            </BaseRecordList>
        </>
    )
}

export default memo(Component)
